// ------------------------------------
// Import SCSS files
// ------------------------------------
import "../sass/pages.scss";

// ------------------------------------
// Scripts
// ------------------------------------
//import "slick-carousel/slick/slick";


// Ceiling simulator component
import './components/ceiling-simulator';
